import { ChevronLeft, ChevronRight, RotateCcw, Calendar } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { Slider } from '@/components/ui/slider';

import { formatWeekDate, getWeekLabel, getRelativeWeekLabel } from '../lib/time-machine.utils';

interface TimeMachineControlProps {
  currentWeek: number;
  minWeek: number;
  maxWeek: number;
  onWeekChange: (week: number) => void;
  onStepBackward: () => void;
  onStepForward: () => void;
  onReset: () => void;
}

export function TimeMachineControl({
  currentWeek,
  minWeek,
  maxWeek,
  onWeekChange,
  onStepBackward,
  onStepForward,
  onReset
}: TimeMachineControlProps) {
  return (
    <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 bg-white rounded-lg shadow-lg p-4 z-[1000] min-w-[400px]">
      <div className="flex items-center gap-2 mb-2">
        <Calendar className="h-4 w-4 text-gray-600" />
        <span className="text-sm font-medium">Time Machine</span>
        <span className="text-sm text-gray-500 ml-auto">{formatWeekDate(currentWeek)}</span>
      </div>

      <div className="flex items-center gap-2">
        <Button size="sm" variant="outline" onClick={onStepBackward} disabled={currentWeek <= minWeek}>
          <ChevronLeft className="h-4 w-4" />
        </Button>

        <div className="flex-1 px-2">
          <Slider
            value={[currentWeek]}
            min={minWeek}
            max={maxWeek}
            step={1}
            onValueChange={([value]) => onWeekChange(value)}
            className="w-full"
          />
        </div>

        <Button size="sm" variant="outline" onClick={onStepForward} disabled={currentWeek >= maxWeek}>
          <ChevronRight className="h-4 w-4" />
        </Button>

        <Button size="sm" variant="outline" onClick={onReset}>
          <RotateCcw className="h-4 w-4" />
        </Button>
      </div>

      <div className="flex justify-between text-xs text-gray-500 mt-2">
        <span>{getRelativeWeekLabel(minWeek)}</span>
        <span className="font-semibold text-gray-700">{getWeekLabel(currentWeek)}</span>
        <span>{getRelativeWeekLabel(maxWeek)}</span>
      </div>
    </div>
  );
}
